(function () {
  var root = document.querySelector('[data-scene="lp"]');
  if (!root) return;
  var st = null, rt = null, raf = 0;
  function q(s) { return root.querySelector(s); }
  // Conteneur qui défile réellement : sur ordinateur (>= 990 px), le thème Horizon fait défiler .page-wrapper et non la fenêtre.
  function scrollerOf(el) {
    var n = el.parentElement;
    while (n && n !== document.documentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && n.scrollHeight > n.clientHeight + 4) return n;
      n = n.parentElement;
    }
    return window;
  }
  function stickyBroken(el, sc) {
    var n = el.parentElement;
    while (n && n !== sc && n !== document.body && n !== document.documentElement) {
      var cs = getComputedStyle(n);
      if (/(hidden|auto|scroll)/.test(cs.overflowX + ' ' + cs.overflowY)) return true;
      n = n.parentElement;
    }
    return false;
  }
  // Courbes d'accélération
  var E = {
    none: function (t) { return t; },
    out: function (t) { return 1 - (1 - t) * (1 - t); },
    io: function (t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; },
    in1: function (t) { return t; }
  };
  // Une piste = valeur de départ + segments [début, fin, valeur d'arrivée, courbe].
  // La valeur est calculée directement à partir de la position de défilement :
  // descendre ou remonter donne toujours exactement la même image.
  function V(track, p) {
    var v = track[0];
    for (var i = 1; i < track.length; i++) {
      var s = track[i], a = s[0], b = s[1];
      if (p <= a) return v;
      if (p >= b) { v = s[2]; continue; }
      var t = (E[s[3] || 'io'])((p - a) / (b - a));
      return v + (s[2] - v) * t;
    }
    return v;
  }
  function build() {
    var wrap = q('.lp-wrap'), stage = q('.lp-stage'), canvas = q('.lp-mist');
    var ST = window.ScrollTrigger;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.innerWidth <= 760;
    var still = reduce || !window.gsap || !ST;
    if (st) { st.kill(true); st = null; }
    cancelAnimationFrame(raf);
    var sc = scrollerOf(root);
    var H = sc === window ? window.innerHeight : sc.clientHeight;
    var usePin = !still && stickyBroken(stage, sc);
    stage.classList.toggle('lp-nosticky', usePin);
    stage.style.height = H + 'px';
    wrap.style.height = still ? H + 'px' : (usePin ? 'auto' : Math.round(H * (mobile ? 3.8 : 5)) + 'px');
    var bottle = q('.lp-bottle'), front = q('.lp-front'), open = q('.lp-open'), glint = q('.lp-glint');
    var mood = q('.lp-mood'), veil = q('.lp-veil'), spot = q('.lp-spot'), intro = q('.lp-intro'), info = q('.lp-info');
    var notes = [q('.lp-n1'), q('.lp-n2'), q('.lp-n3')], base = q('.lp-base');
    var W = stage.clientWidth;
    var S1 = mobile ? 1.08 : 1.16, S2 = mobile ? 0.82 : 0.98, S3 = mobile ? 0.72 : 1;
    var X2 = mobile ? -W * 0.09 : -W * 0.22, Y2 = mobile ? H * 0.17 : H * 0.03, Y3 = mobile ? -H * 0.15 : 0;
    var T = {
      bOp: [1],
      bSc: [0.9, [0.15, 0.35, S1], [0.46, 0.66, S2], [0.86, 0.98, S3]],
      bX: [0, [0.46, 0.66, X2], [0.86, 0.98, 0]],
      bY: [0, [0.46, 0.66, Y2], [0.86, 0.98, Y3]],
      bR: [0, [0.15, 0.35, -13], [0.46, 0.66, -6], [0.86, 0.98, 0]],
      bBl: [0, [0.265, 0.285, 6, 'none'], [0.295, 0.325, 0, 'none'], [0.885, 0.905, 6, 'none'], [0.915, 0.945, 0, 'none']],
      spOp: [1, [0.46, 0.58, 0], [0.9, 0.98, 0.7]],
      spSc: [1],
      inOp: [1, [0.09, 0.16, 0]], inY: [0, [0.09, 0.16, -18]],
      glP: [130, [0.15, 0.32, -30, 'none']], glOp: [1, [0.3, 0.33, 0]],
      opOp: [0, [0.27, 0.305, 1, 'none'], [0.905, 0.935, 0, 'none']],
      frOp: [1, [0.285, 0.32, 0, 'none'], [0.89, 0.92, 1, 'none']],
      m: [0, [0.36, 0.66, 1, 'none']], d: [0, [0.72, 0.85, 1, 'none']],
      moOp: [0, [0.43, 0.51, 0.96, 'none'], [0.85, 0.95, 0.16]],
      moSc: [1.12, [0.56, 0.86, 1, 'none']], moY: [0, [0.56, 0.86, -3, 'none']],
      r: [0, [0.43, 0.69, 165, 'in1']],
      vOp: [0, [0.85, 0.95, 1]],
      ifOp: [0, [0.92, 1, 1, 'out']], ifY: [26, [0.92, 1, 0, 'out']],
      baOp: [0, [0.67, 0.74, 1, 'out'], [0.82, 0.87, 0, 'none']], baY: [20, [0.67, 0.74, 0, 'out']]
    };
    var NS = [0.53, 0.58, 0.63], ND = [-46, -96, -64], NT = [];
    for (var k = 0; k < 3; k++) NT.push({ op: [0, [NS[k], NS[k] + 0.07, 1, 'out'], [0.82, 0.87, 0, 'none']], y: [34, [NS[k], NS[k] + 0.07, 0, 'out'], [0.72, 0.86, ND[k], 'none']] });
    bottle.style.transformOrigin = '50% 60%';
    // Brume
    var N = mobile ? 130 : 280, parts = [], seed = 7;
    function rnd() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
    for (var i = 0; i < N; i++) {
      var ang = (mobile ? -62 : -7) + (rnd() - 0.5) * (mobile ? 40 : 30);
      parts.push({ b: rnd() * 0.62, a: ang * Math.PI / 180, dist: 0.22 + rnd() * 0.62, size: 12 + rnd() * 64, lift: 6 + rnd() * 34, k: 0.55 + rnd() * 0.45 });
    }
    var sprite = document.createElement('canvas'); sprite.width = sprite.height = 128;
    var sg = sprite.getContext('2d'), grd = sg.createRadialGradient(64, 64, 0, 64, 64, 64);
    grd.addColorStop(0, 'rgba(255,238,218,1)'); grd.addColorStop(0.45, 'rgba(255,232,208,0.35)'); grd.addColorStop(1, 'rgba(255,232,208,0)');
    sg.fillStyle = grd; sg.fillRect(0, 0, 128, 128);
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    var ctx = canvas.getContext('2d'), reach = mobile ? H * 0.62 : W * 0.6;
    function draw(m, d) {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      if (m <= 0 || d >= 1) return;
      var s = stage.getBoundingClientRect(), r = open.getBoundingClientRect();
      var nx = r.left - s.left + r.width * 0.354, ny = r.top - s.top + r.height * 0.025;
      root.style.setProperty('--lp-x', (nx / W * 100).toFixed(1) + '%');
      root.style.setProperty('--lp-y', (ny / H * 100).toFixed(1) + '%');
      ctx.globalCompositeOperation = 'lighter';
      for (var j = 0; j < N; j++) {
        var p = parts[j], a = (m - p.b) / 0.36;
        if (a <= 0) continue;
        var c = a > 1 ? 1 : a, t = 1 - Math.pow(1 - c, 3);
        var x = nx + Math.cos(p.a) * reach * p.dist * t, y = ny + Math.sin(p.a) * reach * p.dist * t - p.lift * a;
        var rad = p.size * (0.3 + 0.95 * t);
        var al = Math.min(1, a / 0.1) * (1 - 0.5 * c) * (1 - d) * 0.12 * p.k;
        if (al <= 0.002) continue;
        ctx.globalAlpha = al;
        ctx.drawImage(sprite, x - rad, y - rad, rad * 2, rad * 2);
      }
      ctx.globalAlpha = 1;
    }
    function render(p) {
      bottle.style.opacity = V(T.bOp, p);
      bottle.style.transform = 'translate3d(' + V(T.bX, p).toFixed(1) + 'px,' + V(T.bY, p).toFixed(1) + 'px,0) rotateY(' + V(T.bR, p).toFixed(2) + 'deg) scale(' + V(T.bSc, p).toFixed(4) + ')';
      var bl = V(T.bBl, p); bottle.style.filter = bl > 0.05 ? 'blur(' + bl.toFixed(2) + 'px)' : 'none';
      spot.style.opacity = V(T.spOp, p);
      spot.style.transform = 'translate(-50%,-50%) scale(' + V(T.spSc, p).toFixed(4) + ')';
      intro.style.opacity = V(T.inOp, p); intro.style.transform = 'translateY(' + V(T.inY, p).toFixed(1) + 'px)';
      glint.style.backgroundPosition = V(T.glP, p).toFixed(1) + '% 0'; glint.style.opacity = V(T.glOp, p);
      open.style.opacity = V(T.opOp, p); front.style.opacity = V(T.frOp, p);
      mood.style.opacity = V(T.moOp, p);
      mood.style.transform = 'translateY(' + V(T.moY, p).toFixed(2) + '%) scale(' + V(T.moSc, p).toFixed(4) + ')';
      root.style.setProperty('--lp-r', V(T.r, p).toFixed(2));
      veil.style.opacity = V(T.vOp, p);
      for (var n = 0; n < 3; n++) { notes[n].style.opacity = V(NT[n].op, p); notes[n].style.transform = 'translateY(' + V(NT[n].y, p).toFixed(1) + 'px)'; }
      base.style.opacity = V(T.baOp, p); base.style.transform = 'translateY(' + V(T.baY, p).toFixed(1) + 'px)';
      info.style.opacity = V(T.ifOp, p); info.style.transform = 'translateY(' + V(T.ifY, p).toFixed(1) + 'px)';
      info.style.pointerEvents = p > 0.9 ? 'auto' : 'none';
      draw(V(T.m, p), V(T.d, p));
    }
    if (still) { render(1); return; }
    window.gsap.registerPlugin(ST);
    var target = 0, cur = -1;
    function loop() {
      raf = 0;
      if (cur < 0) cur = target;
      var diff = target - cur;
      cur = Math.abs(diff) < 0.0005 ? target : cur + diff * 0.14;
      render(cur);
      if (cur !== target) raf = requestAnimationFrame(loop);
    }
    function go(p) { target = p; if (!raf) raf = requestAnimationFrame(loop); }
    var cfg = { trigger: usePin ? stage : wrap, start: 'top top', invalidateOnRefresh: true, onUpdate: function (self) { go(self.progress); }, onRefresh: function (self) { go(self.progress); } };
    if (sc !== window) cfg.scroller = sc;
    if (usePin) { cfg.pin = true; cfg.pinSpacing = true; cfg.anticipatePin = 1; cfg.end = '+=' + Math.round(H * (mobile ? 2.8 : 4)); }
    else { cfg.end = 'bottom bottom'; }
    st = ST.create(cfg);
    cur = st.progress; target = st.progress; render(cur);
    root.setAttribute('data-lp-mode', (usePin ? 'pin' : 'sticky') + (sc === window ? '-window' : '-inner'));
  }
  function start() {
    build();
    if (window.ScrollTrigger) {
      window.addEventListener('load', function () { window.ScrollTrigger.refresh(); });
      setTimeout(function () { window.ScrollTrigger.refresh(); }, 1500);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth === lastW) return; lastW = window.innerWidth; clearTimeout(rt); rt = setTimeout(build, 250); });
})();
